<template>
  <div class="header">
    <HeaderTop />
    <HeaderMain />
  </div>
</template>

<script>
import HeaderTop from "./HeaderTop.vue";
import HeaderMain from "./HeaderMain.vue";

export default {
  components: { HeaderTop, HeaderMain },
  data() {
    return {
      scrollY: 0
    };
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    }
  },

  beforeMount() {
    this.scrollY = window.scrollY;
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/Header.vue